import { Box, Modal, InfoCircleIcon } from '@blockanalitica/ui';
import { ReactNode, useState } from 'react';
import styled from 'styled-components';

const InfoIcon = styled(InfoCircleIcon)`
  color: ${(props) => props.theme.colors.muted};

  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.linkHover};
  }
`;

export default function ModalInfo({
  title,
  iconSize = '1',
  children
}: {
  title?: ReactNode;
  iconSize?: string | number;
  children: ReactNode;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <InfoIcon onClick={() => setIsModalOpen(true)} size={iconSize} />
      <Modal open={isModalOpen} onOpenChange={setIsModalOpen} title={title}>
        <Box>{children}</Box>
      </Modal>
    </>
  );
}
